import React from 'react'
import { BannerAlertBox } from '@entur/alert'
import { Paragraph } from '@entur/typography'
import { space } from '@entur/tokens'

type TechnicalErrorProps = {
  title: string
  content: string
}
export const TechnicalError: React.FC<TechnicalErrorProps> = (props) => {
  return (
    <BannerAlertBox variant="error" title={props.title} style={{ marginBottom: space.medium }}>
      <Paragraph> {props.content} </Paragraph>
    </BannerAlertBox>
  )
}

export const technicalError = (props: TechnicalErrorProps) => {
  return <TechnicalError title={props.title} content={props.content} />
}

type FieldErrorProps = {
  failedElements: string[]
}
export const FieldError: React.FC<FieldErrorProps> = (props) => {
  return (
    <BannerAlertBox
      variant="error"
      title="Enkelte felter kunne ikke lagres"
      style={{ marginBottom: space.medium }}
    >
      <ul>
        {props.failedElements?.map((it) => (
          <li key={it}>{it}</li>
        ))}
      </ul>
    </BannerAlertBox>
  )
}

export const fieldsError = (props: FieldErrorProps) => {
  return <FieldError failedElements={props.failedElements} />
}
